import styled from 'styled-components';

export const ActivityStyled = styled.div``;
